import axios from '@axios'
import axiosIns from '@/libs/axios'
import {getUserData} from '@/auth/utils'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {

    fetchMenus(ctx, datas){
        return new Promise((resolve, reject) => {
            axiosIns.get('/menu/list/'+getUserData().store_id,{params:datas})
            .then(response=>resolve(response))
            .catch(error=>reject(error))
        })
    },
    fetchMenu(ctx, id){
        return new Promise((resolve,reject) => {
            axiosIns.get('/menu/'+id)
            .then(response=>resolve(response))
            .catch(error=>reject(error))
        })
    },
    addMenu(ctx,data){
        return new Promise((resolve, reject) => {
            axiosIns.post('/menu', data,
            {
              headers: {
                  'Content-Type': 'multipart/form-data'
              }
            }
            )
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
    },
    deleteMenu(ctx,id){
        return new Promise((resolve, reject) => {
            axiosIns.delete('/menu/'+id).then(response => resolve(response)).catch(error=>reject(error))
        })
    },
    fetchMenuCategories(ctx, datas){
        return new Promise((resolve, reject) => {
            axiosIns.get('/menu/category/list/'+getUserData().store_id, {params:datas})
            .then(response=>resolve(response))
            .catch(error=>reject(error))
        })
    },
    addMenuCategory(ctx, datas){
        return new Promise((resolve, reject) => {
            axiosIns.post('/menu/category', datas)
            .then(response=>resolve(response))
            .catch(error=>reject(error))
        })
    },
    updateMenuCategory(ctx,datas){
        return new Promise((resolve, reject) => {
            axiosIns.put('/menu/category', datas)
            .then(response=>resolve(response))
            .catch(error=>reject(error))
        })
    },
    deleteMenuCategory(ctx,id){
        return new Promise((resolve, reject) => {
            axiosIns.delete('/menu/category/'+id).then(response => resolve(response)).catch(error=>reject(error))
        })
    },
  },
}
